import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_stock_movement_suspension_settings: { message: "idle" },
};

export const retrieve_stock_movement_suspension_settings_Slice = createSlice({
 name: "retrieve_stock_movement_suspension_settings",
 initialState,
 reducers: {
  success_retrieve_stock_movement_suspension_settings: (state, action) => {
   state.retrieve_stock_movement_suspension_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_stock_movement_suspension_settings: (state, action) => {
   state.retrieve_stock_movement_suspension_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_stock_movement_suspension_settings: (state) => {
   state.retrieve_stock_movement_suspension_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_stock_movement_suspension_settings: (state) => {
   state.retrieve_stock_movement_suspension_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_stock_movement_suspension_settings, fail_retrieve_stock_movement_suspension_settings, reset_retrieve_stock_movement_suspension_settings, loading_retrieve_stock_movement_suspension_settings } = retrieve_stock_movement_suspension_settings_Slice.actions;

export default retrieve_stock_movement_suspension_settings_Slice.reducer;